/* T.LUXY Club popup (V25.1: auto-open at most once per page, never again after close)
   V25.5: never on the first page of a visit; popup and Club tab wait until the cookie banner is closed */
(function () {
  var root = document.getElementById('TlxClub');
  if (!root) return;
  var tab = document.getElementById('TlxClubTab');
  var KEY_DONE = 'tlxClubJoined', KEY_SNOOZE = 'tlxClubSnoozeUntil', KEY_PV = 'tlxClubPageviews';
  var delay = (parseInt(root.dataset.delay, 10) || 25) * 1000;
  var scrollPct = parseInt(root.dataset.scroll, 10) || 40;
  var snoozeDays = parseInt(root.dataset.snooze, 10) || 7;
  var preview = root.dataset.preview === 'true';
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  var pageviews = 1;
  try { pageviews = (parseInt(window.sessionStorage.getItem(KEY_PV), 10) || 0) + 1; window.sessionStorage.setItem(KEY_PV, String(pageviews)); } catch (e) {}

  var params = new URLSearchParams(location.search);
  var forced = params.has('tlxclub') || preview;
  if (get(KEY_DONE) && !forced) return;
  var snoozed = Number(get(KEY_SNOOZE) || 0) > Date.now();

  var opened = false, lastFocus = null;
  var autoShown = false, timer = null;
  function cookieBannerOpen() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var cs = getComputedStyle(b);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
  }
  function showTab(wait) {
    if (!tab || get(KEY_DONE)) return;
    setTimeout(function check() {
      if (opened) return;
      if (cookieBannerOpen()) { setTimeout(check, 2000); return; }
      tab.hidden = false;
      requestAnimationFrame(function () { tab.classList.add('is-shown'); });
    }, wait || 0);
  }
  function open() {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    if (tab) tab.classList.remove('is-shown');
    var first = root.querySelector('.tlx-club__step.is-active button, .tlx-club__step.is-active input');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
    if (window.dataLayer) window.dataLayer.push({ event: 'tlx_club_open' });
  }
  function autoOpen() {
    if (autoShown || opened) return;
    if (cookieBannerOpen()) { clearTimeout(timer); timer = setTimeout(autoOpen, 4000); return; }
    autoShown = true;
    clearTimeout(timer);
    open();
  }
  function close(snooze) {
    autoShown = true;
    clearTimeout(timer);
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; opened = false; }, 350);
    if (snooze) set(KEY_SNOOZE, String(Date.now() + snoozeDays * 864e5));
    showTab(400);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function go(step) {
    root.querySelectorAll('.tlx-club__step').forEach(function (s) { s.classList.toggle('is-active', s.dataset.step === String(step)); });
    var f = root.querySelector('.tlx-club__step.is-active input, .tlx-club__step.is-active button');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-tlx-close]')) { close(true); return; }
    var chip = e.target.closest('[data-interest]');
    if (chip) {
      var tags = root.querySelector('[data-tlx-tags]');
      if (tags) tags.value = 'newsletter,club-popup,interesse-' + chip.dataset.interest;
      go(2); return;
    }
    if (e.target.closest('[data-tlx-next]')) { go(2); return; }
    var copy = e.target.closest('[data-tlx-copy]');
    if (copy) {
      var code = copy.dataset.tlxCopy;
      var lbl = copy.querySelector('[data-tlx-copied]');
      var done = function () { if (lbl) lbl.textContent = document.documentElement.lang.indexOf('it') === 0 ? 'Copiato ✓' : 'Copied ✓'; };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close(true); });
  if (tab) tab.addEventListener('click', open);

  var form = document.getElementById('TlxClubForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type=email]');
      var err = form.querySelector('[data-tlx-error]');
      if (!email.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) { if (err) err.hidden = false; email.focus(); return; }
      if (err) err.hidden = true;
      var btn = form.querySelector('[type=submit]');
      btn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', redirect: 'follow' })
        .then(function (r) {
          if (r.url && r.url.indexOf('/challenge') !== -1) { form.submit(); return; }
          set(KEY_DONE, '1');
          if (tab) tab.hidden = true;
          go(3);
          if (window.dataLayer) window.dataLayer.push({ event: 'tlx_club_signup' });
        })
        .catch(function () { form.submit(); })
        .finally(function () { btn.disabled = false; });
    });
  }

  if (forced) { open(); return; }
  if (snoozed) { showTab(1500); return; }
  /* First page of the visit: only the small Club tab, no interruption */
  if (pageviews < 2) { showTab(8000); return; }

  var t0 = Date.now();
  timer = setTimeout(autoOpen, delay);
  if (!isMobile) {
    document.addEventListener('mouseout', function onM(e) {
      if (autoShown) { document.removeEventListener('mouseout', onM); return; }
      if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 6000) { document.removeEventListener('mouseout', onM); autoOpen(); }
    });
  } else {
    window.addEventListener('scroll', function onS() {
      if (autoShown) { window.removeEventListener('scroll', onS); return; }
      var h = document.documentElement;
      var pct = (h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight)) * 100;
      if (pct >= scrollPct && Date.now() - t0 > 10000) { window.removeEventListener('scroll', onS); autoOpen(); }
    }, { passive: true });
  }
})();